import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  LightMode,
} from '@chakra-ui/react';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

interface DeleteModalProps {
  isOpen: boolean;
  dataHeader: string;
  dataBody: string;
  color: string;
  btnAction: string;
  recordDelete: any;
  action: (_record: any) => void;
  onClose: () => void;
  isLoading?: boolean;
  loadingText?: string;
}

const DeleteModal = ({
  isOpen,
  dataHeader,
  dataBody,
  color,
  btnAction,
  recordDelete,
  action,
  onClose,
  isLoading = false,
  loadingText,
}: DeleteModalProps) => {
  const { t } = useTranslation();
  const cancelRef = useRef<HTMLButtonElement>(null);

  return (
    <>
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        returnFocusOnClose={false}
        size={{ base: 'sm', lg: 'lg' }}
      >
        <AlertDialogOverlay>
          <AlertDialogContent pos='absolute' top='23%' color='color_main_text' bg='bg_box'>
            <AlertDialogHeader fontSize={{ base: 'medium', md: 'large' }} fontWeight='bold'>
              {dataHeader}
            </AlertDialogHeader>

            <AlertDialogBody>{dataBody}</AlertDialogBody>

            <AlertDialogFooter>
              <LightMode>
                <Button
                  ref={cancelRef}
                  ml={3}
                  color='black'
                  isDisabled={isLoading}
                  onClick={onClose}
                >
                  {t('common.cancel')}
                </Button>
                <Button
                  ml={3}
                  colorScheme={color}
                  isDisabled={isLoading}
                  isLoading={isLoading}
                  loadingText={loadingText}
                  onClick={() => {
                    action(recordDelete);
                    onClose();
                  }}
                >
                  {btnAction}
                </Button>
              </LightMode>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default DeleteModal;
